/* eslint-disable react/prop-types */
import React from 'react';
import PropTypes from 'prop-types';
import { Box, CircularProgress, Typography } from '@applyboard/ui-components';
import SingleStatus from "./SingleStatus";
import StatusDropdown from "./StatusDropdown";
import { RequirementStatusWrapper } from "./style";
import onClickOutside from "../../../../components/enhancers/onClickOutside";
import { all_status } from "./consts";
var EnhancedDropdown = onClickOutside('onClose')(StatusDropdown);
var RequirementStatus = function RequirementStatus(_ref) {
  var className = _ref.className,
    id = _ref.id,
    status = _ref.status,
    noLabel = _ref.noLabel,
    open = _ref.open,
    onOpen = _ref.onOpen,
    onClose = _ref.onClose,
    onChoose = _ref.onChoose,
    options = _ref.options,
    isInactive = _ref.isInactive,
    loading = _ref.loading,
    statusReadOnly = _ref.statusReadOnly;
  var tooltipMessage = 'Click to change status';
  return /*#__PURE__*/React.createElement(RequirementStatusWrapper, {
    className: className
  }, loading ? /*#__PURE__*/React.createElement(Box, {
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  }, /*#__PURE__*/React.createElement(CircularProgress, {
    size: 36
  }), /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    mt: 1
  }, "Loading...")) : /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(SingleStatus, {
    className: !(statusReadOnly || isInactive) ? 'selectable' : '',
    noLabel: noLabel,
    onClick: onOpen,
    status: status,
    tooltipMessage: !(statusReadOnly || isInactive) ? tooltipMessage : null,
    tooltipId: !isInactive ? "tooltip-".concat(id) : ''
  }), !(statusReadOnly || isInactive) ? /*#__PURE__*/React.createElement(EnhancedDropdown, {
    collapsed: !open,
    onSelect: onChoose,
    onClose: onClose,
    options: options
  }) : null));
};
RequirementStatus.propTypes = {
  status: PropTypes.oneOf(all_status).isRequired,
  noLabel: PropTypes.bool,
  readOnly: PropTypes.bool
};
RequirementStatus.defaultProps = {
  noLabel: false,
  readOnly: false
};
export default RequirementStatus;